define ['./application.css'], () ->
  ($state, $scope, $stateParams) ->
    console.log('application loaded')


// WEBPACK FOOTER //
// ./components/dashboard/view/application/application.coffee